import { render, staticRenderFns } from "./HeadlineComponent.vue?vue&type=template&id=69f4041a&scoped=true"
import script from "./HeadlineComponent.vue?vue&type=script&lang=js"
export * from "./HeadlineComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f4041a",
  null
  
)

export default component.exports